import {mapState} from "vuex";
import _ from "lodash";

export default {
    computed: {
        ...mapState({
            data: function (state) {
                const stateData = this.stateendpoint.split('.').reduce((p, c) => p && p[c] || null, state);
                this.total = stateData.total;
                this.totalAmount = stateData.totalAmount ? stateData.totalAmount : 0;

                return stateData.data;
            },
            user: state => state.user,
            allAdminUsers: state => state.allAdminUsers,
            allPayMethods: state => state.method.allPayMethods,
            actionColumns() {
                return _.find(this.columns, {value: 'action'}) ? this.defaultActionButtons : []
            }
        }),
    }
}